<template>
  <div class="main-layout">
    <div class="main-layout-head">
      <rh-header-main />
    </div>

    <div class="main-layout-center">
      <div class="main-layout-content">
        <router-view />
      </div>

      <div class="main-layout-footer">
        <rh-footer-main />
      </div>
    </div>
  </div>
</template>

<script setup>
import RhHeaderMain from '@/components/RhComponent/RhHeaderMain';
import RhFooterMain from '@/components/RhComponent/RhFooterMain';
</script>

<style lang="scss" scoped>
.main-layout {
  font-size: 14px;
  line-height: 1.5;
  display: flex;
  flex-direction: column;
  height: 100%;

  .main-layout-head {
    flex: 0 0 auto;
  }

  .main-layout-center {
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
    background-color: #f4f8fb;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .main-layout-content {
      width: 1200px;
      margin: 0 auto;
    }

    .main-layout-footer {
      flex: 0;
    }
  }
}
</style>